import api from "./api";

const authHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const medicineService = {
  list: async (token, params = {}) => {
    const res = await api.get("/medicines", {
      ...authHeaders(token),
      params,
    });
    return res.data;
  },

  create: async (payload, token) => {
    const res = await api.post("/medicines", payload, authHeaders(token));
    return res.data;
  },

  updateBatch: async (medicineId, batchId, payload, token) => {
    const res = await api.put(
      `/medicines/${medicineId}/batches/${batchId}`,
      payload,
      authHeaders(token)
    );
    return res.data;
  },

  removeBatch: async (medicineId, batchId, token) => {
    const res = await api.delete(
      `/medicines/${medicineId}/batches/${batchId}`,
      authHeaders(token)
    );
    return res.data;
  },

  moveStock: async (medicineId, batchId, payload, token) => {
    const res = await api.post(
      `/medicines/${medicineId}/batches/${batchId}/stock`,
      payload,
      authHeaders(token)
    );
    return res.data;
  },

  transactions: async (medicineId, batchId, token) => {
    const res = await api.get(
      `/medicines/${medicineId}/batches/${batchId}/transactions`,
      authHeaders(token)
    );
    return res.data;
  },

  search: async (token, { q, type, page, limit }) => {
    const res = await api.get("/medicines/search", {
      ...authHeaders(token),
      params: { q, type, page, limit },
    });
    return res.data;
  },

  exportRecords: async (token, params = {}) => {
    const res = await api.get("/medicines/export", {
      ...authHeaders(token),
      params,
      responseType: "blob",
    });
    return res.data;
  },

  downloadSample: async (token) => {
    const res = await api.get("/medicines/import/sample", {
      ...authHeaders(token),
      responseType: "blob",
    });
    return res.data;
  },

  previewImport: async (file, token, onUploadProgress) => {
    const body = new FormData();
    body.append("file", file);
    const res = await api.post("/medicines/import/preview", body, {
      headers: { Authorization: `Bearer ${token}` },
      onUploadProgress,
    });
    return res.data;
  },

  commitImport: async (file, token, onUploadProgress) => {
    const body = new FormData();
    body.append("file", file);
    const res = await api.post("/medicines/import", body, {
      headers: { Authorization: `Bearer ${token}` },
      onUploadProgress,
    });
    return res.data;
  },
};
